<template>
  <div class="etx-container Container" :class="paragraphClassList">
    <div class="etx-center Center">

      <div class="etx-flex Flex gv-200 tab-l:gv-0 tab-l:nowrap">

        <div class="etx-flex__item Flex__item tab-s:c-10 tab-m:c-9 tab-l:c-4 desk-s:c-3">
          <div class="etx-text Text" :class="entranceClassList">
            <h2 v-if="heading && headingType == 'h2'" class="font-color-primary" :class="headingStyle !== 'standard' ? headingStyle : ''">{{ heading }}</h2>
            <h3 v-if="heading && headingType == 'h3'" class="font-color-primary" :class="headingStyle !== 'standard' ? headingStyle : ''">{{ heading }}</h3>
            <h4 v-if="heading && headingType == 'h4'" class="font-color-primary" :class="headingStyle !== 'standard' ? headingStyle : ''">{{ heading }}</h4>
            <p v-if="headingSubline" class="font-h2 alt">{{ headingSubline }}</p>
          </div>
        </div>

        <div class="etx-flex__item Flex__item mob-m:c-9 mob-l:c-7 tab-s:c-6 tab-m:c-5 tab-l:c-4 desk-s:c-3 mob-m:ml-1 tab-s:ml-1 desk-s:ml-4">

          <div class="etx-card Card CardContact" :class="entranceClassList">

            <div class="etx-card__item Card__item ph-0 pv-0">

              <div class="etx-media Media">
                <MediaImage :media="teamMember?.image" imageStyle="image_1_1" />
              </div>

            </div>

            <div class="etx-card__item Card__item ph-0 pt-75 pb-0">

              <div class="etx-text Text">
                <p class="font-size-larger font-weight-bold">{{ teamMember?.name }} <span class="font-uppercase">{{ teamMember?.surname }}</span></p>
                <p class="font-weight-bold font-color-primary">{{ teamMember?.jobTitle?.label }}</p>
              </div>

              <div class="etx-item-list ItemList ItemList__ContactInfo">

                <a v-if="teamMember?.phone" :href="'tel:' + teamMember?.phone" title="" class="etx-item Item">
                  <div class="etx-item__icon Item__icon"><i class="fal fa-phone"></i></div>
                  <div class="etx-item__text Item__text font-weight-bold"><span>{{ formatSwissPhoneNumber(teamMember?.phone) }}</span></div>
                </a>

                <a v-if="teamMember?.email" :href="'mailto:' + teamMember?.email" title="" class="etx-item Item">
                  <div class="etx-item__icon Item__icon"><i class="fal fa-envelope"></i></div>
                  <div class="etx-item__text Item__text font-weight-bold"><span>{{ teamMember?.email }}</span></div>
                </a>

              </div>

            </div>

          </div>

        </div>

        <div class="etx-flex__item Flex__item tab-s:c-2 tab-s:ml-3 tab-m:ml-4 tab-l:ml-1 desk-s:ml-0 show-0 tab-s:show-1">

          <div class="BrandshapeWrapper falling-off-right desk-l:falling-off-max-right" :class="entranceClassList">

            <div class="Brandshape" :data-color-main="stripeColorMain" :data-color-accent="stripeColorAccent">
              <svg width="208" height="208">
                <use :xlink:href="stripeShape"></use>
              </svg>
            </div>

          </div>

        </div>

      </div>

    </div>
  </div>

</template>

<script lang="ts" setup>

const props = defineProps<{
  heading?: string
  headingType: string
  headingStyle: string
  headingSubline?: string
  teamMember?: {
    name: string
    surname: string
    jobTitle: {
      label: string
    }
    phone?: string
    email?: string
    image: {
      url: {
        path: string
      }
      alt?: {
        alt: string
      }
      title?: string
    }
  }
  stripe: string
}>()

const { options, isEditing } = defineBlokkli({
  bundle: 'team_contact_col_stripe',
  globalOptions: ['spacingTop', 'spacingBottom', 'backgroundColor'],
})

const paragraphClassList = computed(() => {

  const classList = []

  if (options.value.spacingTop) {
    classList.push(options.value.spacingTop)
  }

  if (options.value.spacingBottom) {
    classList.push(options.value.spacingBottom)
  }

  if (options.value.backgroundColor !== 'white') {
    classList.push(options.value.backgroundColor)
  }

  return classList
})

const entranceClassList = computed(() => {
  const classList = []
  if (!isEditing) {
    classList.push('will-appear', 'move-up')
  }
  return classList
})

const stripeShape = computed(() => {
  return '#brandshape-' + props.stripe.split('_')[0]
})

const stripeColorMain = computed(() => {
  return props.stripe.split('_')[1]
})

const stripeColorAccent = computed(() => {
  return props.stripe.split('_')[2]
})


</script>
